import React from 'react';
import '../CSS/Global.css';

const Contact = () => {
    return (
        <>
            <div className="contact-page">
                <h1>Contact Us</h1>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem ipsam nam beatae exercitationem quod tempore libero.</p>
            </div>
            <div className="contact-card">
                <div className="contact-card-list">
                    <i class="fa-solid fa-envelope-open"></i>
                    <div className="contact-info">
                        <h2>Email</h2>
                        <p>mazharkhan189@yahoo.co.in</p>
                    </div>
                </div>
                <div className="contact-card-list">
                    <i class="fa-solid fa-phone"></i>
                    <div className="contact-info">
                        <h2>Call us</h2>
                        <p>+91-9821290637</p>
                    </div>
                </div>
                <div className="contact-card-list">
                    <i class="fa-solid fa-location-dot"></i>
                    <div className="contact-info">
                        <h2>Address</h2>
                        <p>8/42 shri saibaba nagar vira desai road, andheri west,mumbai - 400053</p>
                    </div>
                </div>
            </div>
            <div className="contact-container">
                <div className="map">
                    {/* Embed Google Map */}
                    <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15079.453872042153!2d72.86973389999999!3d19.11364465!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c83c05b7fc89%3A0xbe87eb057f3aafda!2sAndheri%2C%20Maharashtra%20400053!5e0!3m2!1sen!2sin!4v1730173923871!5m2!1sen!2sin" 
                        width="600" 
                        height="350" 
                        style={{ border: 0 }} 
                        allowFullScreen 
                        loading="lazy" 
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                </div>

                <form className="contact-form">
                    <div className="form-group">
                        <label>First Name</label>
                        <input type="text" className="input-field" />
                    </div>
                    <div className="form-group">
                        <label>Last Name</label>
                        <input type="text" className="input-field" />
                    </div>
                    <div className="form-group">
                        <label>Email</label>
                        <input type="email" className="input-field" />
                    </div>
                    <div className="form-group">
                        <label>Contact No.</label>
                        <input type="tel" className="input-field" />
                    </div>
                    <div className="form-group full-width">
                        <label>Subject</label>
                        <textarea className="input-field" rows="4"></textarea>
                    </div>
                    <button type="submit" className="submit-button">Submit</button>
                </form>
            </div>
        </>
    );
}

export default Contact;
